<script>
import feather from "feather-icons";
import ProjectsFilter from "./ProjectsFilter.vue";
import ProjectSingle from "./ProjectSingle.vue";
import projects from "../../data/projects";

export default {
    components: { ProjectSingle, ProjectsFilter },
    data: () => {
        return {
            projects,
            projectsHeading: "Projects Portfolio",
            selectedCategory: "",
            searchProject: "",
        };
    },
    computed: {
        // Get the filtered projects
        filteredProjects() {
            if (this.selectedCategory) {
                return this.filterProjectsByCategory();
            } else if (this.searchProject) {
                return this.filterProjectsBySearch();
            }
            return this.projects;
        },
    },
    methods: {
        // Filter projects by category
        filterProjectsByCategory() {
            return this.projects.filter((item) => {
                let category =
                    item.category.charAt(0).toUpperCase() + item.category.slice(1);
                return category.includes(this.selectedCategory);
            });
        },
        // Filter projects by title search
        filterProjectsBySearch() {
            let project = new RegExp(this.searchProject, "i");
            return this.projects.filter((el) => el.title.match(project));
        },
    },
    mounted() {
        feather.replace();
    },
};
</script>

<template>
    <section class="pt-10 sm:pt-14 pb-20">
        <!-- Projects grid title -->
        <div class="mb-8 border-b border-gray-200 dark:border-gray-800 pb-4">
            <h2
                class="font-mono text-2xl font-bold text-primary-dark dark:text-primary-light"
            >
                > {{ projectsHeading.toLowerCase() }}
            </h2>
        </div>

        <!-- Filter and search projects -->
        <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-8">
            <div class="relative flex-1 max-w-md w-full">
                <span class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <i data-feather="search" class="w-4 h-4 text-gray-400"></i>
                </span>
                <input
                    v-model="searchProject"
                    class="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md text-sm bg-white dark:bg-black text-gray-900 dark:text-gray-100 focus:ring-1 focus:ring-gray-500 focus:border-gray-500 transition-colors"
                    type="search"
                    placeholder="Find a repository..."
                />
            </div>
            <div class="w-full sm:w-auto">
                <ProjectsFilter @filter="selectedCategory = $event" />
            </div>
        </div>

        <!-- Projects list -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ProjectSingle v-for="project in filteredProjects" :key="project.id" :project="project" />
        </div>
    </section>
</template>

<style scoped>
/* Add any additional styles here if needed */
</style>
